import React from "react"
import PropTypes from "prop-types"
import MuiDialogContent from '@material-ui/core/DialogContent';

import classnames from "classnames"
const styleSheet = theme => ({
  gutterTop: {
    paddingTop: theme.spacing.unit * 3,
  },

  gutterBottom: {
    paddingBelow: theme.spacing.unit * 3,
  },
})

function DialogContent({
  classes,
  className: classNameProp,
  gutterTop,
  gutterBottom,

  ...otherProps
}) {
  const className = classnames(
    classes.root,
    {
      [classes.gutterTop]: gutterTop,
      [classes.guterBelow]: gutterBottom,
    },
    classNameProp
  )

  return <MuiDialogContent {...otherProps} className={className} />
}

DialogContent.propTypes = {
  gutterTop: PropTypes.bool,
  gutterBottom: PropTypes.bool,
}

import withStyles from "@material-ui/core/styles/withStyles"
export default withStyles(styleSheet)(DialogContent)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Dialog/DialogContent.js